'use strict';

import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from 'jquery';
import 'slick-carousel';
import SwipeListener from 'swipe-listener';
import { LuminousGallery } from 'luminous-lightbox';
import './libs/header';
import FAQ from './libs/faq';
import FAQCat from './libs/faq-cat';
import AR_Slider from './libs/ar_slider';
import ARS_Slider from './libs/ars_slider';
import PT from './libs/product-tease';
import Artist from './libs/artist';
import Gallery from './libs/gallery';
import Voucher from "./libs/voucher";

$(document).ready(() => {
    $('.slider').each((i, e) => {
        $(e).find('.slider__slides').slick({
            arrows: true,
            dots: true,
            swipeToSlide: true,
            autoplay: true,
            autoplaySpeed: 30000
        });
    });
    new AR_Slider();
    new ARS_Slider();
    // $('.g').each((i, e) => {
    //     new LuminousGallery(e.querySelectorAll('.lb'), {
    //         showCloseButton: true,
    //     });
    // });
    $('.artist').each((i, e) => {
        new LuminousGallery(e.querySelectorAll('.lb'), {
            showCloseButton: true,
        });
    });
    $('.n').each((i, e) => {
        $(e).find('.n__slider').slick({
            arrows: true,
            swipeToSlide: true,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 920,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        });
    });
    $('.faq__single').each((i, e) => {
        new FAQ(e, $('.faq__single'));
    });
    $('.fc__single').each((i, e) => {
        new FAQCat(e, $('.fc__single'));
    });
    $('.pt').each((i, e) => {
        new PT(e);
    });
    $('.voucher__slider').slick({
        arrows: true,
        swipeToSlide: true,
        lazyLoad: 'progressive'
    });
    $('.voucher__gallery').each((i, e) => {
        new LuminousGallery(e.querySelectorAll('.lb'), {
            showCloseButton: true,
        });
    });
    // $('.gallery').each((i, e) => {
    //     new LuminousGallery(e.querySelectorAll('.lb'), {
    //         showCloseButton: true,
    //     });
    // });
    $('.footer__salons').slick({
        arrows: true,
        dots: false,
        swipeToSlide: true,
        slidesToShow: 5,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });
    $('.ar__gallery-wrapper').each((i, e) => {
        const min = $(e).children().length;
        $(e).slick({
            arrows: false,
            dots: false,
            swipeToSlide: true,
            slidesToShow: Math.min(min, 4),
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: Math.min(min, 3),
                    }
                },
                {
                    breakpoint: 920,
                    settings: {
                        slidesToShow: Math.min(min, 2),
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: Math.min(min, 3),
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: Math.min(min, 2),
                    }
                },
            ]
        });
        // new LuminousGallery(e.querySelectorAll('.lb'), {
        //     showCloseButton: true,
        // });
    });
    new Artist($('.single-product .artist'));
    new Gallery($('section.g'));
    new Voucher($('.single-product .voucher'));
    const swipe = SwipeListener($('body')[0]);
    $('body').on('swipe', (e) => {
        const directions = e.detail.directions;
        if (directions.left) {
            $('.lum-open .lum-previous-button').click();
        }
        if (directions.right) {
            $('.lum-open .lum-next-button').click();
        }
    });
    $('#form .more').on('click', function (e) {
        e.preventDefault();
        const $this = $(this);
        const txt = $this.attr('data-txt');
        const $parent = $this.parent();
        $this.remove();
        $parent.text($parent.text() + txt);
    });
});